module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"pt-BR":{"failed":{"title":"Não autorizado","description":"Cobranças que sofreram erro em seu processamento ou não foram autorizadas.","sales":"cobrança | cobrança | cobranças"}},"en-US":{"failed":{"title":"Not authorized","description":"Charges which had an error during its processing stage or that were not authorized.","sales":"charge | charge | charges"}}}')
  delete Component.options._Ctor
}
